module.exports = __webpack_public_path__ + "img/approved_statement.27081490.svg";